export enum ActionOptionsEnum {
  CONFIRM = "confirm",
  CANCEL = "cancel",
}
